import { FC } from 'react';
import { Box, VStack, Text, Grid } from '@chakra-ui/react';
import { MatingRecord } from '@/types/dog';
import { MatingRecordCard } from './MatingRecordCard';

interface MatingRecordListProps {
  matingRecords: MatingRecord[];
  userId: string;
  loading?: boolean;
  error?: string | null;
  onEdit?: (recordId: string) => void;
  onDelete?: (recordId: string) => void;
}

/**
 * 交配記録一覧コンポーネント
 */
export const MatingRecordList: FC<MatingRecordListProps> = ({
  matingRecords,
  userId,
  loading,
  error,
  onEdit,
  onDelete,
}) => {
  /**
   * ローディング表示
   */
  if (loading) {
    return (
      <Box textAlign="center" py={10}>
        <Text color="gray.500">読み込み中...</Text>
      </Box>
    );
  }

  /**
   * エラー表示
   */
  if (error) {
    return (
      <Box p={4} bg="red.50" borderRadius="md" borderWidth={1} borderColor="red.200">
        <Text fontSize="sm" color="red.700">
          {error}
        </Text>
      </Box>
    );
  }

  /**
   * 空状態
   */
  if (matingRecords.length === 0) {
    return (
      <Box p={8} textAlign="center" bg="gray.50" borderRadius="md">
        <Text color="gray.500">交配記録がありません</Text>
      </Box>
    );
  }

  return (
    <VStack gap={4} align="stretch">
      <Text fontSize="sm" color="gray.600">
        全{matingRecords.length}件の交配記録
      </Text>

      <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>
        {matingRecords.map((record) => (
          <MatingRecordCard
            key={record.id}
            matingRecord={record}
            userId={userId}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))}
      </Grid>
    </VStack>
  );
};
